import React from "react";
import { Create, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Switch, Select, InputNumber, Card } from "antd";
import type { ICreateProduct } from "../../interfaces/product";

export const ProductCreate: React.FC = () => {
    const { formProps, saveButtonProps } = useForm<ICreateProduct>({
        resource: "Product",
        redirect: "list",
    });

    const { selectProps: taxSelectProps } = useSelect({
        resource: "taxes",
        optionLabel: "taxType",
        optionValue: "id",
    });

    return (
        <Create saveButtonProps={saveButtonProps}>
            <Form {...formProps} layout="vertical">
                <Card title="Basic Information" style={{ marginBottom: 16 }}>
                    <Form.Item
                        label="Item Code"
                        name="itemCode"
                        tooltip="Leave empty to auto-generate (format: PROD-XXXXXX)"
                        help="Optional - will be auto-generated if left empty"
                    >
                        <Input placeholder="Leave empty to auto-generate" />
                    </Form.Item>

                    <Form.Item
                        label="Product Name"
                        name="itemName"
                        rules={[{ required: true, message: "Product name is required" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Description/Type"
                        name="itemTypeCode"
                        rules={[{ required: true, message: "Type/Description is required" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="HS Code/Classification"
                        name="itemClassificationCode"
                        rules={[{ required: true }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Barcode"
                        name="barcode"
                        rules={[{ required: true, message: "Barcode is required" }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Additional Information"
                        name="additionalInformation"
                    >
                        <Input.TextArea rows={3} />
                    </Form.Item>

                    <Form.Item
                        label="Tax"
                        name="taxId"
                        rules={[{ required: true, message: "Tax is required" }]}
                    >
                        <Select {...taxSelectProps} />
                    </Form.Item>

                    <Form.Item
                        label="Active"
                        name="isActive"
                        valuePropName="checked"
                        initialValue={true}
                    >
                        <Switch />
                    </Form.Item>
                </Card>

                <Card title="Pricing" style={{ marginBottom: 16 }}>
                    <Form.Item
                        label="Base Price"
                        name={["price", "basePrice"]}
                        rules={[{ required: true }]}
                    >
                        <InputNumber min={0} style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                        label="Currency"
                        name={["price", "currencyCode"]}
                        initialValue="USD"
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label="Minimum Quantity"
                        name={["price", "minimumQuantity"]}
                        initialValue={1}
                    >
                        <InputNumber min={1} style={{ width: '100%' }} />
                    </Form.Item>

                    <Form.Item
                        label="Maximum Quantity"
                        name={["price", "maximumQuantity"]}
                        initialValue={999999}
                    >
                        <InputNumber min={1} style={{ width: '100%' }} />
                    </Form.Item>
                </Card>
            </Form>
        </Create>
    );
};

export default ProductCreate;
